import { render, staticRenderFns } from "./enterQuestion.vue?vue&type=template&id=f592622c&scoped=true&"
import script from "./enterQuestion.vue?vue&type=script&lang=js&"
export * from "./enterQuestion.vue?vue&type=script&lang=js&"
import style0 from "./enterQuestion.vue?vue&type=style&index=0&id=f592622c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f592622c",
  null
  
)

export default component.exports